import React from 'react';
import ReactTreeView from 'react-treeview';
import 'react-treeview/react-treeview.css';
import { Tooltip } from '@mui/material';
import { FaFolder, FaFile, FaExternalLinkAlt } from 'react-icons/fa';

const TreeView = ({ treeData }) => {
  const renderTree = (node, parentPath = '') => {
    const currentPath = parentPath ? `${parentPath}/${node.name}` : node.name;
    const url = `https://${currentPath}`;
    const sortedChildren = [...(node.children || [])].sort((a, b) => b.count - a.count);

    const baseLabel = (
      <span className="tree-node-label">
        {node.children?.length > 0 ? (
          <FaFolder className="tree-folder-icon" aria-hidden="true" />
        ) : (
          <FaFile className="tree-file-icon" aria-hidden="true" />
        )}
        {node.name} ({node.count})
        <Tooltip title="Open in new tab">
          <a href={url} target="_blank" rel="noopener noreferrer" className="tree-external-link">
            <FaExternalLinkAlt className="tree-external-icon" />
          </a>
        </Tooltip>
      </span>
    );

    return (
      <ReactTreeView key={currentPath} nodeLabel={baseLabel} defaultCollapsed={true}>
        {sortedChildren.map(child => renderTree(child, currentPath))}
      </ReactTreeView>
    );
  };

  return <div className="tree-container">{renderTree(treeData)}</div>;
};

export default TreeView;